module.exports = __webpack_public_path__ + "static/media/logo_impuls.67d59c0b.png";